import React from "react";
import { ArrowUpRightIcon, Clock3Icon, MapPinIcon, PhoneIcon, UtensilsIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { useSite } from "../context/SiteContext";
import { locations, type LocationId } from "../data/locations";
import { useOpenStatus } from "../hooks/useOpenStatus";
export function LocationCards() {
  const {
    t,
    setSelectedLocation
  } = useSite();
  const isOpen = useOpenStatus();
  const descriptions: Record<LocationId, [string, string]> = {
    driggs: ["Authentic Mexican food on Main Street in Driggs. A welcoming destination for lunch, dinner, family meals, celebrations, and visitors exploring Teton Valley.", "Comida mexicana auténtica en Main Street, Driggs. Un destino acogedor para almuerzos, cenas, comidas familiares, celebraciones y visitantes de Teton Valley."],
    victor: ["A welcoming Mexican kitchen and gathering place in downtown Victor, serving authentic favorites, cocktails, and memorable community experiences.", "Una cocina mexicana y punto de encuentro en el centro de Victor, con platillos auténticos, cócteles y memorables experiencias comunitarias."]
  };
  return <div className="grid gap-5 lg:grid-cols-2" data-id="element-340" data-mp="2a2u24pvgek3s">
      {Object.values(locations).map((location, index) => <article key={location.id} className="relative overflow-hidden rounded-2xl border border-sand/30 bg-white p-7 text-charcoal sm:p-9" data-id="element-341" data-mp="2etu2k53s7kb1" data-mpi={index}>
          <div className="mb-8 flex items-center justify-between" data-id="element-342" data-mp="2juq62hk814fx">
            <span className="text-xs font-bold uppercase tracking-[.24em] text-terracotta" data-id="element-343" data-mp="2opx170zfd0t8">
              {location.id}
            </span>
            <MapPinIcon className={`h-5 w-5 ${index === 0 ? "text-forest" : "text-agave"}`} aria-hidden="true" data-id="element-344" data-mp="2xs67tfrkoa1c" />
          </div>

          <h3 className="max-w-md font-serif text-3xl font-semibold text-cocoa sm:text-4xl" data-id="element-345" data-mp="ygvdoylych5i">
            {location.officialName}
          </h3>
          <p className="mt-4 max-w-xl text-sm leading-7 text-charcoal/70" data-id="element-346" data-mp="26oj5fm7hfgn7">
            {t(...descriptions[location.id])}
          </p>

          <address className="mt-6 not-italic text-sm font-semibold" data-id="element-347" data-mp="21r9h69vtxb0y">
            <a href={location.directionsUrl} target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-terracotta" data-id="element-348" data-mp="2fpzi60lrruul">
              {location.address}
            </a>
            <br data-id="element-349" data-mp="2plkd5esf7uuu" />
            <a href={location.phoneHref} className="mt-2 inline-block transition-colors hover:text-terracotta" data-id="element-350" data-mp="2kou1r4rk9nfr">
              {location.phone}
            </a>
          </address>

          <div className="mt-8 flex flex-wrap gap-3" data-id="element-351" data-mp="2uedhw2nw336x">
            <Link onClick={() => setSelectedLocation(location.id)} to={location.pagePath} className={`inline-flex min-h-11 items-center gap-2 rounded-full px-5 text-sm font-bold text-white transition-colors ${index === 0 ? "bg-mexicangreen hover:bg-[#005036]" : "bg-blueagave hover:bg-[#127287]"}`} data-id="element-352" data-mp="2ugq790vz8fu0">
              <UtensilsIcon className="h-4 w-4" aria-hidden="true" data-id="element-353" data-mp="3d364xri34bey" />
              {t("Visit Us", "Visítanos")}
            </Link>

            <a href={location.directionsUrl} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-11 items-center gap-2 rounded-full border border-sand px-5 text-sm font-bold transition-colors hover:border-charcoal" data-id="element-354" data-mp="3i0zacibkd1e6">
              {t("Directions", "Cómo llegar")}
              <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-355" data-mp="2ualfyl5iaqgf" />
            </a>

            <span className="inline-flex min-h-11 items-center gap-2 rounded-full border border-sand px-5 text-sm font-bold" aria-live="polite" aria-label={t(`Open Hours: currently ${isOpen ? "open" : "closed"}`, `Horario: actualmente ${isOpen ? "abierto" : "cerrado"}`)} data-id="element-356" data-mp="2z9ewkmg3axkt">
              <Clock3Icon className="h-4 w-4 text-terracotta" aria-hidden="true" data-id="element-357" data-mp="2dbk8aifmbgwb" />
              <span data-id="element-358" data-mp="28jae2q7gzuo8">{t("Open Hours", "Horario")}</span>
              <span className={`h-2 w-2 rounded-full ${isOpen ? "bg-mexicangreen" : "bg-mexicanred"}`} aria-hidden="true" data-id="element-359" data-mp="23l8rvweqzf8j" />
              <span className={isOpen ? "text-mexicangreen" : "text-mexicanred"} data-id="element-360" data-mp="1zkyp0sm954xw">
                {t(isOpen ? "Open" : "Closed", isOpen ? "Abierto" : "Cerrado")}
              </span>
            </span>

            <a href={location.phoneHref} className="inline-flex min-h-11 items-center justify-center rounded-full border border-sand px-4 transition-colors hover:border-charcoal" aria-label={`${t("Call", "Llamar")} ${location.officialName}`} data-id="element-361" data-mp="1plpv1zrdzqbj">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-362" data-mp="3f17aorzq9fmy" />
            </a>
          </div>
        </article>)}
    </div>;
}